<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M13.7334 3.47116L10.5912 0.329596C10.4867 0.225103 10.3627 0.142213 10.2262 0.0856601C10.0897 0.0291075 9.94335 0 9.79559 0C9.64783 0 9.50152 0.0291075 9.36501 0.0856601C9.22851 0.142213 9.10448 0.225103 9.00001 0.329596L0.329771 8.99983C0.224851 9.10392 0.141667 9.22782 0.0850551 9.36434C0.0284434 9.50086 -0.000466481 9.64727 5.69176e-06 9.79506V12.9373C5.69176e-06 13.2357 0.118532 13.5218 0.329511 13.7328C0.540489 13.9438 0.826637 14.0623 1.12501 14.0623H12.9375C13.0867 14.0623 13.2298 14.0031 13.3353 13.8976C13.4407 13.7921 13.5 13.649 13.5 13.4998C13.5 13.3506 13.4407 13.2076 13.3353 13.1021C13.2298 12.9966 13.0867 12.9373 12.9375 12.9373H5.85844L13.7334 5.06233C13.8379 4.95786 13.9208 4.83383 13.9774 4.69732C14.0339 4.56081 14.063 4.4145 14.063 4.26674C14.063 4.11899 14.0339 3.97267 13.9774 3.83617C13.9208 3.69966 13.8379 3.57563 13.7334 3.47116ZM7.31251 3.60756L8.48602 4.78108L2.53126 10.7358L1.35774 9.56233L7.31251 3.60756ZM1.12501 12.9373V10.9201L3.14227 12.9373H1.12501ZM4.50001 12.7046L3.32719 11.5311L9.28126 5.57631L10.4548 6.74983L4.50001 12.7046ZM11.25 5.9546L8.10844 2.81233L9.79594 1.12483L12.9375 4.2671L11.25 5.9546Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'Pencil',
};
</script>
